import React from "react";
import WhatwedoBglanding from "./WhatwedoBglanding";
import WhatwedoHeading from "./WhatwedoHeading";
import { Box, Typography } from "@mui/material";
import WhatwedoContent from "./WhatwedoContent";
import { Helmet } from "react-helmet";

const Whatwedo = () => {
  return (
    <>
      <Helmet>
        <title>
          Inteliphyle | Unparalleled Understanding of Marketing and Business
          Issues
        </title>
        <meta
          name="description"
          content="From digital strategy to retail expansion, our solutions drive ROI. Partner with us for strategic insights to elevate your business in today's dynamic market environment."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <WhatwedoBglanding />
        <WhatwedoHeading />
        <WhatwedoContent />
        <Typography
          sx={{
            textAlign: "left",
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Plus Jakarta Sans",
            padding: { xs: "1rem", sm: "1rem 0 1rem 4rem" },
          }}
        >
          Partner with us to navigate the complexities of marketing, innovation,
          GTM, and digital landscapes, and unlock the full potential of your
          business.
        </Typography>
      </Box>
    </>
  );
};

export default Whatwedo;
